import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import UserSettingsConnections from './UserSettingsConnections';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	userId: string;
}

const UserSettingsConnectionsModal: React.FC<Props> = props => (
	<BaseModal title='layout.menu.apiToken' {...props} size={Size.MD}>
		<UserSettingsConnections userId={props.userId} />
	</BaseModal>
);

export default UserSettingsConnectionsModal;
